import * as Sentry from '@sentry/react';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import { Col, Row, message } from "antd";
import { DeleteModal } from "components/Dialog";
import SpinLoader from "components/Loader/SpinLoader";
import { cloneDeep, map } from "lodash";
import { usePageVocabContent } from "store/page_translations/selectors";
import { handleDeleteVocabContent, handleUpdateVocabContent } from "store/page_translations/thunks";
import styled from "styled-components";
import COLOR from "utils/constants/color";

import {
    AutoAwesome,
    Close,
    Delete
} from '@mui/icons-material';
import {
    Button,
    FormControl,
    FormHelperText,
    IconButton,
    InputLabel,
    Autocomplete,
    Modal,
    TextareaAutosize,
    TextField
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import BadgeButton from '../BadgeButton';












const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 200px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: auto;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    // margin-left:5px;
    // margin-top:5px;
`;
const CustomFormHelperText = styled(FormHelperText)`
 color:red !important;
  .MuiFormHelperText-root{
  color:red !important;
  }
`

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: '4px',
    },
  }));
const VocabContentToolBar = ({ bookId, pageId, pages: currentBookPages = [], hasPermission = true }) => {
    const showAlert = useAlert();
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false)
    const classes = useStyles();
        const scrollRef = useRef();
    const dispatch = useDispatch()
    const [openModal, setOpenModal] = useState(false);
    const [page_contents, setPageContents] = useState([])
    const { book_vocb_content } = usePageVocabContent()
    const [content, setContent] = useState([{
        title: "",
        prompt: "",
        from_page:pageId,
        to_page:'',
    }])
    const has_page_content = useMemo(() => page_contents.find((page_content) => page_content.page == pageId), [page_contents, pageId])
    
    const dropdownPages = useMemo(() => {
        if (currentBookPages && Array.isArray(currentBookPages) && currentBookPages.length > 0) {
            return currentBookPages
                .filter((page) => {
                    const mask = page.NumberMasked ?? page.pageId;
                    return !isNaN(Number(mask));
                })
                .map((page) => ({
                    ...page,
                    NumberMasked: page.NumberMasked || `Page ${page.pageId}`,
                    pageId: parseInt(page.pageId)
                }));
        }
        return [];
    }, [currentBookPages]);
    useEffect(() => {
        if (openModal) {
            if (has_page_content) {
                setContent(has_page_content?.content)
            } else {
                setContent([{
                    title: "",
                    prompt: "",
                    from_page:pageId,
                    to_page:'',
                }])
            }
        }
    }, [has_page_content, openModal, pageId])
    useEffect(() => {
        if (book_vocb_content) {
            setPageContents(book_vocb_content)
        } else {
            setPageContents([])
        }
    }, [book_vocb_content, bookId])

    const addVocabContent = () => {
        const h = cloneDeep(content);
        h.push({
            title: "",
            prompt: ""
        });
        setContent(h);
        setTimeout(() => {
            if (scrollRef.current) {
                scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
            }
        }, 500);
    };
    const removeVocabContent = (index) => {
        const h = cloneDeep(content);
        h.splice(index, 1);
        setContent(h);
        setError(false);
    };

    const onUpdate = async ({ }) => {
        const content_item = content[0];
       const has_all_filed = content.every((c) => c.title && c.from_page)
       if(!has_all_filed||content.length ==0){
        setError('All fields are required')
        return 
       }
        if (content_item.from_page && content_item.to_page) {
            if (content_item.from_page > content_item.to_page) {
                setError('From page must be less than to page')
                return
            } else if (parseInt(content_item.to_page, 10) - parseInt(content_item.from_page, 10) >= 3) {
                setError('Maximum three page can be select.')
                return
            }
        } else if(!content_item.from_page){
            setError('From page is required')
            return
        }
        setLoading(true)
        try {
            await dispatch(handleUpdateVocabContent({
                id: has_page_content?.id,
                chapter: bookId,
                page: pageId,
                content
            }))
            showAlert("AI Vocab. content updated successfully ✅","success")
            setOpenModal(false)
        } catch (error) {
            Sentry.captureException(`308 Error updating vocab content: ${error}`);
            showAlert("Something went wrong!","error")
        } finally {
            setLoading(false)
            setError(false);
        }
    }
    const onDelete = async () => {
        setDeleteLoader(true)
        try {
            const dt = await dispatch(handleDeleteVocabContent(has_page_content?.id));
            if(dt&&dt.success) {
                showAlert(`AI Vocab. content removed successfully`,"success")
                setOpenModal(false)
            }else{
                showAlert("Something went wrong!","error")
            } 
        } catch (error) {
            Sentry.captureException(`309 Error deleting vocab content: ${error}`);
            console.log(error,"error in  Vocab. content remove.")
        } finally {
            setDeleteLoader(false)
            setDeleteModal(false)
        }
        
      
    }
    const onClose = () => {
        setOpenModal(false)
    }
    const onChnageContent = (index, key, value) => {
        const h = cloneDeep(content);
        if (h[index]) {
            h[index][key] = value;
            setContent([...h]);
            setError(false);
        }else{
            setError("Something went wrong!")
        }

    };
    return (<>
        <BadgeButton
            onClick={() => {
                if (!hasPermission) {
                    message.warning('You do not have permission to access this feature.');
                    return;
                }
                setOpenModal(true);
            }}
            startIcon={<AutoAwesome />}
            showBadge={has_page_content}
            backgroundColor="#667eea"
        >
            Vocab. AI Activity
        </BadgeButton>
        <SpinLoader dataloader={loading} />
        <DeleteModal
            deleteToggle={deleteModal}
            loading={deleteLoader}
            onDelete={onDelete}
            setDeleteToggle={setDeleteModal}
            message={`Are you sure you want to remove the  Vocab. AI content on pageId ${pageId}?`} />
        <Modal
            open={openModal}
            onClose={onClose}
            style={{ height: "100%", width: "100%" }}
        >
            <ModalContent style={{ width: "60vw" }}>
                <Row style={{ justifyContent: "space-between" }}>
                    {/* <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Add />}
                        onClick={addVocabContent}
                        style={{ marginTop: 10 }}
                    >
                        Add prompt
                    </Button> */}
                    {has_page_content ? <IconButton
                        onClick={() => {
                            setDeleteModal(true)
                        }}
                        style={{ padding: 0 }}
                    >
                        <Delete color="secondary" />
                    </IconButton> : null}
                    <IconButton
                        onClick={() => onClose()}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <ModalConfigArea ref={scrollRef}>
                    {map(content, ({ title , prompt , from_page , to_page }, i) => (
                        <LinkArea key={i}>
                            <Row
                                gutter={[24, 24]}
                                style={{ justifyContent: "flex-end", display: "flex" }}
                            >
                                {/* {content.length == 1 ? null : <IconButton
                                    onClick={() => removeVocabContent(i)}
                                    style={{ padding: 0, marginRight: 10 }}
                                >
                                    <Delete color="secondary" />
                                </IconButton>} */}
                            </Row>
                            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                                <Col span={24}>
                                    <TextField
                                        id="title"
                                        name="title"
                                        label="Title"
                                        InputLabelProps={{ shrink: true , required:true }}
                                        type="text"
                                        required
                                        variant="outlined"
                                        onChange={(e) => {
                                            onChnageContent(i, "title", e.target.value);
                                        }}
                                        value={title}
                                    />
                                </Col>
                            </Row>
                            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                                <Col span={24}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="textTip" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>AI Prompt</InputLabel>
                                        <TextAreaAuto
                                            id="prompt"
                                            type="text"
                                            minRows={3}
                                            maxRows={5}
                                            variant="outlined"
                                            onChange={(e) => {
                                                 onChnageContent(i, "prompt", e.target.value);
                                            }}
                                            value={prompt}
                                        />
                                    </FormControl>
                                </Col>
                            </Row>
                            <Row gutter={[24, 24]} style={{ marginTop: 20 }}>
                                <Col span={12}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel id="from-page-label">From Page</InputLabel>
                                        <Autocomplete
                                            id="fromPage"
                                            options={dropdownPages || []}
                                            getOptionLabel={(option) => {
                                                if (!option || typeof option !== 'object') return '';
                                                const pageId = option.pageId != null ? option.pageId : '';
                                                return String(option.NumberMasked || `Page ${pageId}` || '');
                                            }}
                                            isOptionEqualToValue={(option, value) => {
                                                if (!option || !value) return false;
                                                return parseInt(option.pageId) === parseInt(value.pageId);
                                            }}
                                            value={(() => {
                                                if (!from_page || !dropdownPages || dropdownPages.length === 0) return null;
                                                const fromPageId = parseInt(from_page);
                                                return dropdownPages.find(page => parseInt(page.pageId) === fromPageId) || null;
                                            })()}
                                            onChange={(event, newValue) => {
                                                const h = cloneDeep(content);
                                                if (h[i]) {
                                                    h[i]["from_page"] = newValue ? newValue.pageId : '';
                                                    h[i]["to_page"] = '';
                                                    setContent([...h]);
                                                    setError(false);
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label="From Page" 
                                                    variant="outlined" 
                                                    required
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '0px'
                                                        },
                                                        '& .MuiOutlinedInput-input': {
                                                            padding: '14px 14px'
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Col>
                                <Col span={12}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel id="to-page-label">To Page</InputLabel>
                                        <Autocomplete
                                            id="toPage"
                                            options={(() => {
                                                if (!from_page || !dropdownPages) return [];
                                                
                                                const fromPageId = parseInt(from_page);
                                                
                                                return dropdownPages.filter(page => {
                                                    const pageId = parseInt(page.pageId);
                                                    return pageId >= fromPageId;
                                                }).sort((a, b) => parseInt(a.pageId) - parseInt(b.pageId));
                                            })()}
                                            getOptionLabel={(option) => {
                                                if (!option || typeof option !== 'object') return '';
                                                const pageId = option.pageId != null ? option.pageId : '';
                                                return String(option.NumberMasked || `Page ${pageId}` || '');
                                            }}
                                            isOptionEqualToValue={(option, value) => {
                                                if (!option || !value) return false;
                                                return parseInt(option.pageId) === parseInt(value.pageId);
                                            }}
                                            value={(() => {
                                                if (!to_page || !dropdownPages) return null;
                                                const toPageId = parseInt(to_page);
                                                return dropdownPages.find(page => parseInt(page.pageId) === toPageId) || null;
                                            })()}
                                            onChange={(event, newValue) => {
                                                const h = cloneDeep(content);
                                                if (h[i]) {
                                                    h[i]["to_page"] = newValue ? newValue.pageId : '';
                                                    setContent([...h]);
                                                    setError(false);
                                                }
                                            }}
                                            disabled={!from_page}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label="To Page" 
                                                    variant="outlined"
                                                    placeholder={!from_page ? "Please select 'From Page' first" : "Select ending page"}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            padding: '0px'
                                                        },
                                                        '& .MuiOutlinedInput-input': {
                                                            padding: '14px 14px'
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Col>
                            </Row>
                        </LinkArea>
                    ))}
                </ModalConfigArea>
                {error ? (
                    <CustomFormHelperText>
                        {error}
                    </CustomFormHelperText>
                ) : null}
                <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
                >
                    <Button
                        fullWidth
                        onClick={onUpdate}
                        disabled={content.length ===0}
                        color="primary"
                        variant="contained"
                    >
                        Update
                    </Button>
                </Row>
            </ModalContent>
        </Modal>
    </>)
}

export default VocabContentToolBar;